import { BowlMixIcon } from './BowlMixIcon';

/**
 * author: Austin Andrews
 * id 95E70948-C85D-41AC-887C-62752FBA7B6B
 * name bowl-mix
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bowl-mix.svg
 * tags
 * - Food / Drink 
 */
export const MixingBowlIcon = BowlMixIcon;
export default MixingBowlIcon